import { CommonGet, CommonPost, CommonGetIDServer, CommonPostIDServer } from "../../../utils/CommonFetch";

export default {
    GetAllCollectionPoints,
    GetAllCardsByCollectionPointID,
    getAllUsers,
    getAllOperationEntitiesForDropDown,
    getOperationEntityByID,
    getEOSData,
    completeEOS,
    GetActiveAspNetUser
};

async function getEOSData(data) {
    const response = await CommonPost('/api/EOS/GetAllEOS', null, data);
    return response.data;
}

async function completeEOS(eos) {
    delete eos.packageName;
    var response = await CommonPost('/api/EOS/CompleteEOS', null, eos);
    return response;
}

async function GetAllCollectionPoints(id, groupID) {

    var model = {
        groupID: groupID,
        operationEntityID: id
    }

    var collectionPointArray = [];

    const response = await CommonPost('/api/CollectionPoint/GetCollectionPointByOperationEntityId', null, model);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return collectionPointArray;
}

async function GetAllCardsByCollectionPointID(collectionPointID, packageID) {
    var cardsArray = [];
    let cardFilterModel = {
        collectionpointID: collectionPointID.toString(),
        cardID: packageID.toString()
    };
    const response = await CommonPost('/api/Card/GetAvailabaleOperationCardsForPackages', null, cardFilterModel);
    for (let item of Object.entries(response.data)) {
       cardsArray[item[1]["cardID"]] = item[1]["nameToBePrinted"]
    }
    return cardsArray;
}

async function getAllUsers(groupID, operationEntityID) {
    
    var usersArray = [];
    var response = await CommonGetIDServer('/Admin/GetAllTipsUsers', null);
    for (let item of Object.entries(response)) {
        if (item[1] !== undefined && item[1]["isActive"] === true && item[1]["groupID"] === parseInt(groupID) 
            && item[1]["operationEntityID"] === parseInt(operationEntityID))
            usersArray[item[1]["aspNetUserId"]] = item[1]["userName"];
    }
    return usersArray;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getOperationEntityByID(operationEntityID) {
    var response = await CommonGet('/api/OperationEntity/GetOperationEntityByID', 'operationEntityID=' + operationEntityID);
    return response.data;
}

async function GetActiveAspNetUser(groupID, operationEntityID) {
     
    var FilterUserModel = {
        groupID: groupID,
        operationEntityID: operationEntityID
    }

    var usersArray = [];
    var response = await CommonPost('/api/User/GetActiveUser', null, FilterUserModel);

    for (let item of Object.entries(response.data)) {
        usersArray[item[1]["aspNetUserId"]] = item[1]["userName"]
    }

    return usersArray;

}